import React from 'react';

const FormCheckbox = ({
  label,
  id,
  name,
  checked,
  onChange,
  error,
  disabled = false,
  className = '',
  helpText,
  ...props
}) => {
  const fieldId = id || name;
  const hasError = !!error;
  
  return (
    <div className={`space-y-2 ${className}`}>
      <div className="flex items-center">
        <input
          id={fieldId}
          name={name}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={`h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded ${hasError ? 'border-red-500' : ''} ${disabled ? 'bg-gray-50 cursor-not-allowed' : ''}`}
          {...props}
        />
        {label && (
          <label 
            htmlFor={fieldId} 
            className={`ml-2 block text-sm text-gray-700 ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}
          >
            {label}
          </label>
        )}
      </div>
      
      {helpText && !error && (
        <p className="text-sm text-gray-500">{helpText}</p>
      )}
      
      {error && (
        <p className="text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default FormCheckbox;